var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.698004 16.391C0.592046 7.83127 7.44521 0.806314 16.005 0.700356C24.5647 0.594398 31.5897 7.44756 31.6956 16.0073C31.8016 24.5671 24.9484 31.592 16.3887 31.698C7.82891 31.8039 0.803962 24.9508 0.698004 16.391Z",
    fill: "#E0DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.698004 16.391C0.592046 7.83127 7.44521 0.806314 16.005 0.700356C24.5647 0.594398 31.5897 7.44756 31.6956 16.0073C31.8016 24.5671 24.9484 31.592 16.3887 31.698C7.82891 31.8039 0.803962 24.9508 0.698004 16.391Z",
    stroke: "#A69FF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8639 16.1384L11.5312 16.2539",
    stroke: "#0A0A0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2584 20.8647L11.5343 16.2562L16.1429 11.5321",
    stroke: "#0A0A0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoBack);
export default __webpack_public_path__ + "static/media/bo-back.9220508a9183125e1d97c27b2bf8bf1a.svg";
export { ForwardRef as ReactComponent };